export interface IOrigemProcesso {
    id: OrigemProcesso;
    descricao: string;
}

export enum EnumOrigemProcesso {
    PJE = "P",
    LEGADO = "L"
}


export class PJe {
    id: string = EnumOrigemProcesso.PJE;
    descricao: string = 'PJe';
}

export class Legado {
    id: string = EnumOrigemProcesso.LEGADO;
    descricao: string = 'Legado';
}

export type OrigemProcesso = 'P' | 'L' | '' | 'PL' | 'LP' | undefined;